<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-I">For Aimée, my wife, best friend, and writing partner.</span></p>
<p class="DED"><span class="ePub-I">You are with me every hour of every day.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2a637b85